module.exports = __webpack_public_path__ + "img/agreement-yes.0374eb20.svg";